import React from 'react';
import styled, {css} from 'styled-components';
import {tabletAndUp} from '../../../../constants/customMedia';
import {FONT_SIZES} from '../../../../constants/typography';
import {Button as BaseButton} from '../../../atoms/Buttons/Button';
import {UnstyledLink} from '../../../atoms/UnstyledLink/UnstyledLink';

export type CTAStyle = 'primary' | 'secondary' | 'text-link';

interface CTAText {
  text: string;
  style: CTAStyle;
  textColor?: string;
}

export interface ContentBlockCTAProps {
  className?: string;
  text: CTAText;
  link: {
    url: string;
  };
  testId?: string;
  onClick?: VoidFunction;
}

export const ContentBlockCTA: React.FC<ContentBlockCTAProps> = ({
  link,
  text,
  testId = 'contentBlockCTA',
  className,
  onClick,
}) => {
  if (text.style === 'text-link') {
    return (
      <Styledlink
        className={className}
        to={link.url}
        $textColor={text.textColor}
        data-testid={`${testId}-${text.style}`}
        onClick={onClick}
      >
        {text.text}
      </Styledlink>
    );
  }

  return (
    <Button
      className={className}
      href={link.url}
      variant={text.style}
      $textColor={text.textColor}
      data-testid={`${testId}-${text.style}`}
      onClick={onClick}
    >
      {text.text}
    </Button>
  );
};

const baseCSS = css<{$textColor?: string}>`
  font-size: ${FONT_SIZES.px14};

  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px16};
  `)}

  ${({$textColor}) =>
    $textColor &&
    css`
      color: ${$textColor} !important;
    `}
`;

const Button = styled(BaseButton)`
  ${baseCSS}
`;

const Styledlink = styled(UnstyledLink)`
  ${baseCSS}

  text-align: center;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
